
export class DutiesDivPlanGoodsModel {


  // 選択チェック
  public SelectCheck = String('');

  // 部門コード名称
  public ClassCodeName = String('');

  // 小分類コード名称
  public SmallClassCodeName = String('');

  // 商品案内用商品名
  public GuideGoodsName = String('');

  // 商品案内用規格名
  public GuideStandardName = String('');

  // 取扱フラグ（いばらき）
  public HandlingCoop1 = String('');

  // 取扱フラグ（とちぎ）
  public HandlingCoop2 = String('');

  // 取扱フラグ（ぐんま）
  public HandlingCoop3 = String('');

  // 取扱フラグ（ちば）
  public HandlingCoop4 = String('');

  // 取扱フラグ（さいたま）
  public HandlingCoop5 = String('');

  // 取扱フラグ（とうきょう）
  public HandlingCoop6 = String('');

  // 取扱フラグ（ながの）
  public HandlingCoop7 = String('');

  // 取扱フラグ（にいがた）
  public HandlingCoop8 = String('');

  // 取扱フラグ（クルコ）
  public HandlingCoop9 = String('');

  // Ｐコード
  public Pcode = String('');

  // 業態区分（デイリー）
  public DutiesFormDailyDiv = String('');

  // 更新日時
  public UpdateDate = String('');

  // 変更フラグ
  public ChangeFlag = String('');
}
